export class PaginatedList {
  list: Array<any> = [];
  totalItems: number;

  constructor(list: Array<any>, totalItems: number) {
    this.list = list;
    this.totalItems = totalItems;
  }
}
